import React from "react";
import { ReactSVG } from "react-svg";
import { BookOpenText, Plus, Search, X } from "lucide-react";
import { TbTriangleInvertedFilled } from "react-icons/tb";
import syncIcon from "../../../Asset/sync.svg";

const DictionaryPanel = ({
  dictionaryLoading,
  dictionarySaving,
  dictionaryQuery,
  setDictionaryQuery,
  dictionaryWordsCount,
  filteredDictionaryWords,
  dictionaryError,
  onRefresh,
  onAdd,
  onRemove,
}) => {
  return (
    <div className="relative z-20 overflow-visible rounded-2xl border border-[#D6ECFB] bg-white p-3">
      <div className="relative z-20 overflow-visible flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 text-xl md:text-[1.75rem] font-semibold font-inter">
          <span className="bg-gradient-to-b from-[#3AB1F6] to-[#407BFF] text-white p-1.5 rounded-lg">
            <BookOpenText className="md:size-5 size-4" />
          </span>
          Dictionary
        </div>

        <div className="relative z-30 group">
          <button
            type="button"
            onClick={onRefresh}
            disabled={dictionaryLoading || dictionarySaving}
            className="inline-flex items-center justify-center rounded-lg p-2 text-[#2196F3] hover:bg-[#EDF5FB] disabled:opacity-50"
            aria-label="Refresh dictionary"
          >
            <ReactSVG
              src={syncIcon}
              beforeInjection={(svg) =>
                svg.setAttribute("class", `w-4 h-4 ${dictionaryLoading ? "animate-spin" : ""}`)
              }
              className="w-4 h-4"
            />
          </button>

          <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 whitespace-nowrap bg-black text-white text-xs px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-[70] shadow-lg pointer-events-none">
            Sync Now
            <TbTriangleInvertedFilled className="absolute -bottom-2 left-1/2 -translate-x-1/2 text-black z-[70]" />
          </span>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-2">
        <div className="flex-1 h-10 rounded-xl bg-[#EDF5FB] flex items-center gap-2 px-3">
          <Search className="size-4 text-[#9CA3AF]" />
          <input
            type="text"
            placeholder="Search a word..."
            value={dictionaryQuery}
            onChange={(e) => setDictionaryQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onAdd();
              }
            }}
            className="w-full bg-transparent outline-none text-sm font-inter placeholder:text-[#9CA3AF]"
          />
        </div>

        <button
          type="button"
          onClick={onAdd}
          disabled={dictionarySaving}
          className="h-10 min-w-[82px] px-4 rounded-xl bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] text-white text-sm font-semibold font-inter inline-flex items-center justify-center gap-1.5"
        >
          <Plus className="size-4" />
          {dictionarySaving ? "..." : "Add"}
        </button>
      </div>

      <div className="mt-4 flex flex-wrap gap-2 max-h-32 overflow-y-scroll pr-1 custom-scrollbar content-start">
        {dictionaryLoading && <div className="text-sm text-[#6B7280] font-inter">Loading...</div>}

        {!dictionaryLoading && dictionaryError && (
          <div className="text-sm text-red-600 font-inter">{dictionaryError}</div>
        )}

        {!dictionaryLoading &&
          !dictionaryError &&
          filteredDictionaryWords.map((item, idx) => (
            <button
              key={`${item}-${idx}`}
              type="button"
              onClick={() => onRemove(item)}
              disabled={dictionarySaving}
              className="inline-flex items-center gap-1 rounded-lg bg-[#EDF5FB] text-[#2196F3] px-2.5 py-1.5 text-sm font-medium font-inter"
            >
              <span>{item}</span>
              <X className="size-3.5" />
            </button>
          ))}

        {!dictionaryLoading && !dictionaryError && filteredDictionaryWords.length === 0 && (
          <div className="text-sm text-[#6B7280] font-inter">
            {dictionaryWordsCount ? "No matching words." : "No dictionary words found."}
          </div>
        )}
      </div>
    </div>
  );
};

export default DictionaryPanel;
